// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"513e86ac","541":"40b47e61","545":"eb9077d1","787":"c4dc4428"}[chunkId] + ".chunk.js";
};